<template>
  <button
      v-if="coachBill.coachingType === 'private_coaching'"
      class="btn btn-primary"
      @click.prevent="cancellationBill(coachBill.id, 'private_coaching')">
    {{ $t('general.cancellation') }}
  </button>
  <button
      v-if="
        coachBill.coachingType === 'group_coaching' &&
        coachBill.billingType === 'pauschalbetrag'"
      class="btn btn-primary"
      @click.prevent="cancellationBill(coachBill.id, 'group_coaching_pauschal')">
    {{ $t('general.cancellation') }}
  </button>
  <button
      v-else-if="
          coachBill.coachingType === 'group_coaching' &&
          coachBill.billingType !== 'pauschalbetrag'"
      class="btn btn-primary"
      @click.prevent="cancellationBill(coachBill.id, 'group_coaching_hourly_wages')">
    {{ $t('general.cancellation') }}
  </button>
  <button
      v-if="coachBill.coachingType === 'assisted_living_coaching'"
      class="btn btn-primary"
      @click.prevent="cancellationBill(coachBill.id, 'assisted_living_coaching')">
    {{ $t('general.cancellation') }}
  </button>
  <button
      v-if="coachBill.coachingType === 'case_management_coaching'"
      class="btn btn-primary"
      @click.prevent="cancellationBill(coachBill.id, 'case_management_coaching')">
    {{ $t('general.cancellation') }}
  </button>
</template>

<script setup>
import { CloseToast } from '@/components/VueToast';
import { defineEmits, defineProps } from 'vue';

const emit  = defineEmits([ 'billCancellation' ]);
const props = defineProps({
  coachBill: {
    type: Object,
    required: true,
  },
});

const cancellationBill = (id, billType) => {
  CloseToast();
  emit('billCancellation', id, billType);
};

</script>
